import { render } from "./OverlayFrame.vue?vue&type=template&id=81d52fc4"
import script from "./OverlayFrame.vue?vue&type=script&lang=js"
export * from "./OverlayFrame.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matthew/Documents/Vault/code/sal/beatentodeath/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__